// @flow

import FacilityView from "./FacilityView";

export default FacilityView;
